/**
 * 指定のAPIの実行中の件数を返却する
 * @param fetch
 * @param condition
 * @returns {*}
 */
export const countLoadingApis = (fetch, condition) => {
    switch (typeof condition) {
        case 'string': {
            const { loadingApis } = fetch;
            return loadingApis.filter((api) => api.type === condition).length;
        }
        case 'object': {
            const { loadingApis } = fetch;
            const keys = Object.keys(condition);
            return loadingApis.filter((api) => {
                const metas = api.meta || {};
                return keys.every((key) => metas[key] === condition[key]);
            }).length;
        }
        case 'function': {
            const { loadingApis } = fetch;
            return loadingApis.filter(condition).length;
        }
        default: {
            throw Error(`Unknown condition type: ${typeof condition}`);
        }
    }
};
/**
 * 指定のAPIが実行中かどうか
 * @param fetch
 * @param condition
 * @returns {boolean}
 */
export const isLoadingApis = (fetch, condition) => countLoadingApis(fetch, condition) > 0;
/**
 * 指定のAPIのいずれかが実行中かどうか
 * @param f
 * @param conditions
 * @returns {boolean}
 */
export const isLoadingOrApis = (f, conditions) => !!conditions.find((c) => isLoadingApis(f, c));
/**
 * APIが実行中かどうか（軽量版）
 * @param state
 * @param action
 * @param id
 * @returns {boolean|*}
 */
export const isLoading = (state, action, id = '') => {
    const key = id ? `${action}_${id}` : action;
    return state.fetch.loadings[key];
};
/**
 * APIが実行中かどうか（軽量版）
 * @param state
 * @param action
 * @param id
 * @param undefinedIsTrue
 * @returns {boolean|*}
 */
export const isLoadingIfUndefined = (state, action, id, undefinedIsTrue = true) => {
    const loading = isLoading(state, action, id);
    if (loading === undefined) {
        return undefinedIsTrue;
    }
    return loading;
};
